export default __webpack_public_path__ + "static/media/customers.7a6618e6.svg";